module.exports = __webpack_public_path__ + "step04.jpg?d7f2d8f202f263c59b27565068382106";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step04.jpg
// module id = 104
// module chunks = 0